// Mobile lume tap-swap for the collection grid.
// Desktop uses Dawn's :hover opacity crossfade between front (img[0]) and
// lume (img[1]). Touch devices never fire :hover, so on touch-capable
// viewports we mirror the behaviour via a class toggle and a first-tap
// intercept on the card anchor.
//
// UX: first tap on a card reveals the lume shot (no nav). Second tap
// follows the link to the PDP. Tapping away resets any revealed card.
// Only active at <=749px (mobile breakpoint) and only on touch devices.
(function () {
  if (typeof window === 'undefined') return;
  const isTouch = window.matchMedia('(hover: none)').matches || 'ontouchstart' in window;
  if (!isTouch) return;

  const REVEAL_CLASS = 'twco-lume-revealed';

  function clearAll(except) {
    document.querySelectorAll('.' + REVEAL_CLASS).forEach(function (el) {
      if (el !== except) el.classList.remove(REVEAL_CLASS);
    });
  }

  document.addEventListener('click', function (e) {
    // Only act on collection pages where cards exist.
    const card = e.target.closest('.card-wrapper');
    if (!card) {
      clearAll(null);
      return;
    }
    // Only cards that actually have a second image (hover-swap target).
    const imgs = card.querySelectorAll('.card__media img');
    if (imgs.length < 2) return;
    // Respect narrow viewports only.
    if (window.innerWidth > 749) return;

    if (!card.classList.contains(REVEAL_CLASS)) {
      // First tap: reveal, swallow navigation.
      e.preventDefault();
      e.stopPropagation();
      clearAll(card);
      card.classList.add(REVEAL_CLASS);
    }
    // Second tap: class is already set, let the click bubble to the anchor.
  }, true);
})();
